import React, { FC } from 'react';
import { FullHeightLoader } from '../../common/FullHeightLoader';
import { GenericLayoutComponent } from './GenericLayout.component';
import { enhance } from './GenericLayout.enhancers';
import { IOuter } from '../types';

const EnhancedGenericLayout = enhance(GenericLayoutComponent);

export const GenericLayout: FC<IOuter> = (props) =>
  props.isLoading ? <FullHeightLoader {...props} /> : <EnhancedGenericLayout {...props} />;
